export default __webpack_public_path__ + "static/media/Prototype_2.58305455.png";